import { Immutable } from '@zervant/reactcomponents'
import { StateInterface } from 'client/Interfaces/StateInterface'

import { ModalInterface } from '../Interfaces/ModalInterface'
import { ReducerBuilder } from './ReducerBuilder'

const path = location.pathname
const [mod, view] = path.split('/').slice(1)
const app = { mod, view }

export const INITIAL_STATE = {
  path,
  app,
  modals: [],
  invoiceEditorLoading: false,
}

interface StateType {
  path?: string
  app?: {
    mod?: string
    view?: string
  }
  modals?: ModalInterface[]
  origin?: string
  invoiceEditorLoading?: boolean
}

function navigateAddModal(state: StateType, payload: ModalInterface): StateType {
  const { modals } = state
  return { ...state, modals: [...modals, payload] }
}

function navigateRemoveModal(state: StateType, payload: string): StateType {
  const { modals } = state
  return { ...state, modals: modals.filter(({ component }) => component !== payload) }
}

function navigateChangeModal(state: StateType, payload: ModalInterface): StateType {
  const newState = Immutable.copy(state)
  const modal = newState.modals.find((modal) => modal.component === payload.component)
  if (modal) {
    modal.props = payload.props
  }
  return newState
}

function setNavigationPath(state: StateType, path: string) {
  return { ...state, path, origin: state.path }
}

function setNavigation(state: StateType, updatedState: StateType) {
  return Object.assign({}, state, updatedState)
}

function setInvoiceEditorLoading(state: StateType) {
  return Object.assign({}, state, { invoiceEditorLoading: true })
}

function setInvoiceEditorLoaded(state: StateType) {
  return Object.assign({}, state, { invoiceEditorLoading: false })
}

const openScreen = (state: StateType, screen) => {
  return {
    ...state,
    screen,
  }
}

const closeScreen = (state: StateType, screen) => {
  return {
    ...state,
    screen: null,
  }
}

export default ReducerBuilder.create(INITIAL_STATE)
  .mapAction('NAVIGATE_ADD_MODAL', navigateAddModal)
  .mapAction('NAVIGATE_REMOVE_MODAL', navigateRemoveModal)
  .mapAction('NAVIGATE_CHANGE_MODAL', navigateChangeModal)
  .mapAction('SET_NAVIGATION_PATH', setNavigationPath)
  .mapAction('SET_NAVIGATION', setNavigation)
  .mapAction('SET_INVOICE_EDITOR_LOADING', setInvoiceEditorLoading)
  .mapAction('SET_INVOICE_EDITOR_LOADED', setInvoiceEditorLoaded)
  .mapAction('NAVIGATE_OPEN_SCREEN', openScreen)
  .mapAction('NAVIGATE_CLOSE_SCREEN', closeScreen)
  .build()

// useSelector
export const getNavigationSelector = (state: StateInterface): StateType => state.navigation
